import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppState, Actions, store, IPageState,} from 'appredux'

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Paper, WithStyles, SvgIconTypeMap, CardMedia } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

//import './Paper.css'
//import './PanelRight.css'
//import './LeftPanel.css';
//import { fontSelect } from '../fonts'

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Backdrop from '@material-ui/core/Backdrop';
import MenuIcon from '@material-ui/icons/Menu';
import HistoryIcon from '@material-ui/icons/History';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// import LocalDiningIcon from '@material-ui/icons/LocalDining';
// import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
// import HistoryIcon from '@material-ui/icons/History';
// import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import HomeIcon from '@material-ui/icons/Home'
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
//import CONFIG from '../cfg/config';

import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import LocalDiningIcon from '@material-ui/icons/LocalDining';
import GpsIcon from '@material-ui/icons/GpsFixed'
import HomeIcon from '@material-ui/icons/Home'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import LockIcon from '@mui/icons-material/Lock';
import PasswordIcon from '@mui/icons-material/Password';
import FiberPinIcon from '@mui/icons-material/FiberPin';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import OknoKod from './OknoKod';

import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { DARK_BUTTON_COLOR, DARK_TEXT_COLOR } from 'App';


//PM 2021-06-25
interface MenuProps {
  page: IPageState,
  lightMode: boolean,
  setTheme: () => void,
}

interface MenuState {
    anchorEl: any,
    openKod: boolean,
  }
  

class PanelLeftTest extends React.Component<MenuProps & WithTranslation & WithStyles<typeof styles>, MenuState>  {
  //logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`

  constructor(props: MenuProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
        anchorEl: null,
        openKod: false,
      };
  }

  openMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  openKod = () => {
    this.setState({ openKod: true });
    this.closeMenu();
  }
  closeKod = () => {
    this.setState({ openKod: false });
  };

  // openKodyBledow = () => {
  //   //store.dispatch(Actions.pageState.setDisplayState(DisplayState.kodyBledow));
  //   this.closeMenu();

  //   localStorage.setItem("openKodyBledow", "true");
  //   localStorage.setItem("jezykKodyBledow", this.props.page.lang);

  //   setTimeout(() => {
  //     localStorage.removeItem("openKodyBledow")
  //     localStorage.removeItem("jezykKodyBledow")
  //   }, 5000); //50s

  //   window.open(window.location.href, '_blank');
  // }



  //PM 2021-06-25
  render = () => {
    const { classes, t } = this.props;

    const openMenu = Boolean(this.state.anchorEl);


    let menuItems = [
      {
        key: "7",
        className: `${classes.menuItem}`,  //${classes.divider}
        onClick: () => { this.openKod() },
        classNameText: `${classes.menuText}`,
        classNameIcon: classes.orange,
        opis: "     " + ("admin"),
        Icon: PersonIcon as any,
      },
    ]

    

        
        

      

    return (
      <>
          <OknoKod open={this.state.openKod} closeDialog={this.closeKod}/>

            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.openMenu}
                style={{position: "absolute", zIndex: "9", marginLeft: "10px", padding: "4px", right: "16px", color: this.props.page.lightMode ? "" : "white"}}
            >
                <MoreVertIcon />
            </IconButton>
            <Backdrop className={classes.backdrop} open={openMenu}>
                <Menu
                    id="long-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    //elevation={15}
                    open={openMenu}
                    onClose={this.closeMenu}
                    PaperProps={{
                        style: {
                            //maxHeight: 10 * 4.5,
                            width: '30ch',
                            left: "200px",
                            top: "200px",
                            boxShadow: '0px 0px 10px rgb(0 0 0 / 20%), 0px 0px 10px rgb(0 0 0 / 14%), 0px 0px 10px rgb(0 0 0 / 12%)',
                            borderRadius: 0,
                            //paddingTop: "0"
                            background: this.props.lightMode ? "" : DARK_BUTTON_COLOR,
                        },
                    }}

                    MenuListProps={{
                        style: {
                            //maxHeight: 10 * 4.5,
                            //width: '30ch',
                            color: "#555",
                            width: "100%",
                            paddingRight: "0"
                            //paddingTop: "0",
                            //paddingBottom: "0"
                        },
                    }}
                >

                    {/*<hr/>*/}
              
                    

                    {menuItems.map(menuItem => (
                        <MenuItem key={menuItem.key} className={menuItem.className} onClick={menuItem.onClick}>
                            {menuItem.Icon ? <menuItem.Icon className={menuItem.classNameIcon} style={{width: "24px", height: "24px"}}/> : <div style={{width: "24px"}}></div>}
                            <Typography className={`${menuItem.classNameText} ${this.props.lightMode ? "" : classes.darkModeText}`} 
                                //color='textSecondary'
                                variant='caption'
                            >
                                {menuItem.opis}
                            </Typography>
                        </MenuItem>
                    ))}

            <MenuItem key={"99"}  >
              <FormControlLabel className='' classes={{label: `${classes.label} ${this.props.lightMode ? "" : classes.darkModeText}`}}
                control={<MaterialUISwitch sx={{ m: 1 }} defaultChecked={!this.props.lightMode} onClick={this.props.setTheme} />}
                label={this.props.lightMode ? "tryb jasny" : "tryb ciemny"} 
              />
              {/* {menuItem.Icon ? <menuItem.Icon className={menuItem.classNameIcon} style={{ width: "24px", height: "24px" }} /> : <div style={{ width: "24px" }}></div>} */}
              {/* <Typography className={menuItem.classNameText}
                //color='textSecondary'
                variant='caption'
              >
                {menuItem.opis}
              </Typography> */}
            </MenuItem>
            {/* <ResponsiveImgMaterialUi style={{ width: "100%", maxWidth: "calc(100%  + -20px)", maxHeight: "220px", padding: "10px 10px 0px" }}
              xs={this.logoUrl}
              md={this.logoUrl}
              lg={this.logoUrl}
            /> */}
            {/* <CardMedia
                    style={{ width: "100%", maxWidth: "calc(100%  + -20px)", maxHeight: "220px", padding: "10px 10px 0px" }}
                    image={this.logoUrl}
                  //title="logo"
                  component="img"
                  onError={(event: any) => event.target.style.display = 'none'}
                  /> */}
                   
                   

                </Menu>
            </Backdrop>
      </>
    )
  }
}

//do wywalenia
const styles = (theme: Theme) => {
  return ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        //color: '#fff',
        //backgroundColor: "rgba(0, 0, 0, 0.06)",
        backgroundColor: "rgba(0, 0, 0, 0.00)",
      },
      //backdrop: {
        //backgroundColor: "rgba(0, 0, 0, 0.06)",
        //backgroundColor: "white",
      //},
      divider: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundClip: 'padding-box',
      },
      dividerTop: {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundClip: 'padding-box',
      },
      menuItem: {
        whiteSpace: "pre" as "pre",
        paddingBottom: "8px",
        paddingTop: "8px",
        minHeight: "44px",
      },
      menuText: {
        fontSize: "0.9rem",
        color: "#555"
      },
      label: {
        fontSize: "0.9rem !important",
        color: "#555"
      },
      green: {
        //color: 'rgba(69, 139, 0, 0.5)'
        color: theme.palette.primary.main
      },
      blueDark: {
        //color: 'rgba(0, 90, 126, 0.5)'
        color: theme.palette.secondary.main
      },
      brownLight: {
        //color: 'rgba(191, 136, 85, 0.5)'
        color: 'rgba(191, 136, 85, 0.8)'
      },
      orange: {
        //color: theme.palette.error.main
        color: "rgb(255, 140, 0)"
      },
      darkModeText: {
        color: DARK_TEXT_COLOR
      },
      darkModePaper: {
        background: DARK_BUTTON_COLOR
      }
   
  });
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

//export default PanelLeftTest;
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(PanelLeftTest)));




const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  zoom: 0.7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : 'rgb(255, 140, 0)',
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));




